import VueVirtualScroller from 'vue-virtual-scroller';
import SbsFaIcons from 'sbs-fa-icons';
import 'ie11-custom-properties';
import 'intersection-observer';
import './scss/index.scss';
import * as components from './components/index.js';
import directives from './directives/index.js';
import * as mixins from './mixins/index.js';
import * as utils from './utils/index.js';

/**
 * @typedef { import('vue/types/plugin').PluginObject } PluginObject
 * @type { PluginObject }
 */
const SbsUiKitPlugin = {
    install(VueInstance, options = {}) {
        Object.keys(components).forEach(componentName => {
            const component = components[componentName];

            VueInstance.component(componentName, component);
        });

        Object.keys(mixins).forEach(mixinName => {
            const mixin = mixins[mixinName];

            VueInstance.mixin(mixin);
        });

        Object.keys(directives).forEach(directiveName => {
            const directive = directives[directiveName];

            VueInstance.directive(directiveName, directive);
        });

        VueInstance.use(VueVirtualScroller, {
            ...options.SbsVirtualScroller,
            componentsPrefix: 'Sbs',
        });

        VueInstance.use(SbsFaIcons, options.SbsFaIcon);
    },
};

export { utils as Utils };
export default SbsUiKitPlugin;
